import { Theme, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { add, areIntervalsOverlapping, differenceInMinutes, eachHourOfInterval, format, isWithinInterval, set } from "date-fns";
import _, { forEach } from "lodash";
import { IVirtualTrip } from "../../../common/plannerTypes";
import { IPlannerLabel, IPlannerMinute, ITripPlanner, ClosePeriodType } from "../types/plannerTypes";
import store from "../../../store/appStore";
import moment from "moment";

const closedStartPeriod = 60;
const closedEndPeriod = 120;

export const convertTZ = (date:any, tzString:string|null):any =>{
  if(tzString !== null)
  {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));   
  }
 else{
  return new Date();
 }
}

export const convertTZConvertion = (date:any, tzString:string|null):any =>{
  if(tzString !== null)
  {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));   
  }
 else{
  return new Date(date);
 }
}

const getDateTime = (selectedDay: string, minutes: number): Date => {
  return add(set(new Date(selectedDay), { hours: 0, minutes: 0, seconds: 0 }), { minutes: minutes });
};

const adjustTimeToHours = (minutes: number, isItStart: boolean): number => {
  if (minutes % 60 === 0) return minutes;

  return isItStart ? minutes - (minutes % 60) : minutes + (60 - (minutes % 60));
};

const getStartMinutes = (minutes: number | null, adjustment: number = 0): number =>
  minutes === null ? 420 : adjustTimeToHours(minutes + adjustment, true);

const getEndMinutes = (minutes: number | null, adjustment: number = 0): number =>
  minutes === null ? 1200 : adjustTimeToHours(minutes + adjustment, false);

const getFirstWorkMinute = (plannerStartTime: number) => plannerStartTime - getStartMinutes(plannerStartTime, -closedStartPeriod);
const getLastWorkMinute = (lastId: number, plannerEndTime: number) => lastId - (getEndMinutes(plannerEndTime, closedEndPeriod) - plannerEndTime);

const prepareTimelineLabels = (tripPlanner: ITripPlanner, selectedDay: string): IPlannerLabel[] => {
  const startDate = getDateTime(selectedDay, getStartMinutes(tripPlanner.plannerStartTime, -closedStartPeriod));
  const endDate = getDateTime(selectedDay, getEndMinutes(tripPlanner.plannerEndTime, closedEndPeriod));
  const hours = eachHourOfInterval({
    start: startDate,
    end: endDate,
  }).map((h) => ({ hourStr: `${h.getHours()}:00`, hour:h }));

  hours[0].hourStr = "";
  hours[hours.length - 1].hourStr = "";
  return hours;
};

const defineTripForMinute = (
  trips: IVirtualTrip[],
  timeBlockDate: Date,
  localState: IVirtualTrip[],
  draggingTripId: string | null
): {
  trip: IVirtualTrip | null;
  isOverlapped: boolean;
  isTripBlockStart: boolean;
  isTripBlockEnd: boolean;
  isTripStart: boolean;
  isTripEnd: boolean;
  isOverlappedEnd: boolean;
  isOverlappedStart: boolean;
  isConflictingTrip: boolean;
  isInsivible: boolean;
} => {
  let tripsInInterval = trips.filter((q) => isWithinInterval(timeBlockDate, { start: q.startTrip, end: (q.isTripMinOverrided == true ? q.overridedendTrip : q.endTrip) }));
  if (tripsInInterval.length === 0) {
    return {
      trip: null,
      isOverlapped: false,
      isTripBlockStart: false,
      isTripBlockEnd: false,
      isTripStart: false,
      isTripEnd: false,
      isOverlappedEnd: false,
      isOverlappedStart: false,
      isConflictingTrip: false,
      isInsivible: false,
    };
  } 
  if (tripsInInterval.length === 1 && tripsInInterval[0].virtualTripId === draggingTripId) {
    return {
      trip: tripsInInterval[0],
      isOverlapped: false,
      isTripBlockStart: tripsInInterval[0].startTrip.getTime() === timeBlockDate.getTime(),
      isTripStart: tripsInInterval[0].startTrip.getTime() === timeBlockDate.getTime(),
      isTripBlockEnd: Math.round(((tripsInInterval[0].isTripMinOverrided == true ? tripsInInterval[0].overridedendTrip.getTime() : tripsInInterval[0].endTrip.getTime())  - timeBlockDate.getTime()) / 60000) < 5,
      isTripEnd: Math.round(((tripsInInterval[0].isTripMinOverrided == true ? tripsInInterval[0].overridedendTrip.getTime() : tripsInInterval[0].endTrip.getTime()) - timeBlockDate.getTime()) / 60000) < 5,
      isOverlappedEnd: false,
      isOverlappedStart: false,
      isConflictingTrip: false,
      isInsivible: true,
    };
  }

  tripsInInterval = tripsInInterval.filter(t => t.virtualTripId !== draggingTripId)
  
  if (tripsInInterval.length > 1) {
    const tripsStarts = tripsInInterval.filter((t) => t.startTrip.getTime() === timeBlockDate.getTime());
    const tripsEnds = tripsInInterval.filter((t) => Math.round((t.isTripMinOverrided == true ? t.overridedendTrip.getTime() : t.endTrip.getTime()) - timeBlockDate.getTime()) / 60000 < 5);
    for (const overlappedTrip of tripsInInterval) {
      const foundInLocalState = localState.find((l) => !l.deletedFromTimeLine && l.virtualTripId === overlappedTrip.virtualTripId);
      if (foundInLocalState) {
        const conflictingTrips = trips.filter((q) =>
          areIntervalsOverlapping({ start: overlappedTrip.startTrip, end: (overlappedTrip.isTripMinOverrided == true ? overlappedTrip.overridedendTrip : overlappedTrip.endTrip) }, { start: q.startTrip, end: (q.isTripMinOverrided == true ? q.overridedendTrip : q.endTrip) })
        );
        return {
          trip: overlappedTrip,
          isOverlapped: true,
          isTripBlockStart: tripsInInterval.length === tripsStarts.length,
          isTripBlockEnd: tripsInInterval.length === tripsEnds.length,
          isTripStart: overlappedTrip.startTrip.getTime() === timeBlockDate.getTime(),
          isTripEnd: Math.round(((overlappedTrip.isTripMinOverrided == true ? overlappedTrip.overridedendTrip.getTime() : overlappedTrip.endTrip.getTime()) - timeBlockDate.getTime()) / 60000) < 5,
          isOverlappedEnd: tripsEnds.length > 0,
          isOverlappedStart: tripsStarts.length > 0,
          isConflictingTrip: conflictingTrips.length > 1 && conflictingTrips[0].virtualTripId === overlappedTrip.virtualTripId,
          isInsivible: false,
        };
      }
    }
  }
  const conflictingTrips = trips.filter((q) =>
    areIntervalsOverlapping({ start: tripsInInterval[0].startTrip, end: (tripsInInterval[0].isTripMinOverrided == true ? tripsInInterval[0].overridedendTrip : tripsInInterval[0].endTrip) }, { start: q.startTrip, end: (q.isTripMinOverrided == true ? q.overridedendTrip : q.endTrip) })
  );
  return {
    trip: tripsInInterval[0],
    isOverlapped: false,
    isTripBlockStart: tripsInInterval[0].startTrip.getTime() === timeBlockDate.getTime(),
    isTripStart: tripsInInterval[0].startTrip.getTime() === timeBlockDate.getTime(),
    isTripBlockEnd: Math.round(((tripsInInterval[0].isTripMinOverrided == true ? tripsInInterval[0].overridedendTrip.getTime() : tripsInInterval[0].endTrip.getTime()) - timeBlockDate.getTime()) / 60000) < 5,
    isTripEnd: Math.round(((tripsInInterval[0].isTripMinOverrided == true ? tripsInInterval[0].overridedendTrip.getTime() : tripsInInterval[0].endTrip.getTime()) - timeBlockDate.getTime()) / 60000) < 5,
    isOverlappedEnd: false,
    isOverlappedStart: false,
    isConflictingTrip: conflictingTrips.length > 1 && conflictingTrips[0].virtualTripId === tripsInInterval[0].virtualTripId,
    isInsivible: false,
  };
};

const prepareTimelineContent = (
  tripPlanner: ITripPlanner,
  selectedDay: string,
  trips: IVirtualTrip[],
  localState: IVirtualTrip[],
  draggingTripId: string = "",
): IPlannerMinute[] => {
  const listTimeBlocks: IPlannerMinute[] = [];
  var startDate = getDateTime(selectedDay, getStartMinutes(tripPlanner.plannerStartTime, -closedStartPeriod));
  var endDate = getDateTime(selectedDay, getEndMinutes(tripPlanner.plannerEndTime, closedEndPeriod));
  var tz =tripPlanner.timezone;
 // startDate =convertTZ(startDate,localStorage.getItem("Timezone"));
  //endDate=convertTZ(endDate,localStorage.getItem("Timezone"));
  const minutes = differenceInMinutes(endDate, startDate);
  //const minutes = 1710;
  const firstWorkingMinute = getFirstWorkMinute(tripPlanner.plannerStartTime ?? 0);
  const lastWorkingMinute = getLastWorkMinute(minutes, tripPlanner.plannerEndTime ?? 0);
  //var timeNow = new Date()
  // var timeWithLead = new Date()
  var timeNow = convertTZ(new Date(),tz);
  var timeWithLead= convertTZ(new Date(),tz);
  timeWithLead.setMinutes(timeWithLead.getMinutes() + (tripPlanner?.schedulingLeadTtime|| 0));
  for (let index = 0; index <= minutes; index = index + 5) {
    const timeBlockDate = set(startDate, { minutes: index });
    const { trip, isOverlapped, isTripBlockStart, isTripBlockEnd, isTripStart, isTripEnd, isOverlappedStart, isOverlappedEnd, isConflictingTrip, isInsivible } = defineTripForMinute(
      trips,
      timeBlockDate,
      localState,
      draggingTripId
    );
    const isDnD = index >= firstWorkingMinute && index < lastWorkingMinute && timeBlockDate >= timeWithLead && (tripPlanner.open || false);
    const timeBlock: IPlannerMinute = {
      id: index,
      date: timeBlockDate,
      trip: trip,
      tripPlannerId: tripPlanner.tripPlannerId,
      isDnD: isDnD,
      isPassed: timeBlockDate <= timeNow,
      sharingRole : null,
      sharedPlannerId : null,
      timezone:tripPlanner.timezone,
      tripStyle: {
        isOverlapped: isOverlapped,
        isTripBlockStart: isTripBlockStart,
        isTripBlockEnd: isTripBlockEnd,
        isTripStart: isTripStart,
        isTripEnd: isTripEnd,
        isOverlappedStart: isOverlappedStart,
        isOverlappedEnd: isOverlappedEnd,
        isConflictingTrip: isConflictingTrip,
        isInsivible: isInsivible,
      },
    };
    listTimeBlocks.push(timeBlock);
  }
  return listTimeBlocks;
};

const calcClosedPeriod = (
  minuteWidth: number,
  quarterMinuteWidth: number,
  hourWidth: number,
  closePeriodType: ClosePeriodType,
  timelineContent: IPlannerMinute[],
  tripPlanner: ITripPlanner
): number => {
  if (timelineContent.length === 0) return 0;
  let from = 0;
  let to = 0;
  switch (closePeriodType) {
    case ClosePeriodType.start:
      from = 0;
      to = getFirstWorkMinute(tripPlanner.plannerStartTime ?? 0);
      break;
    case ClosePeriodType.end:
      const lastId = timelineContent[timelineContent.length - 1].id;
      const lastWorkingMinute = getLastWorkMinute(lastId, tripPlanner.plannerEndTime ?? 0);
      from = lastWorkingMinute < 1 ? 1 : lastWorkingMinute;
      to = lastId + 1;
      break;
    default:
      break;
  }

  const closedPeriodList = timelineContent.filter((minute) => minute.id >= from && minute.id < to);
  const closedPeriodWidth = _.sumBy(closedPeriodList, (item): any => {
    const mins = item.date.getMinutes();
    if (mins % 60 === 0) return hourWidth;
    if (mins % 15 === 0) return quarterMinuteWidth;
    return minuteWidth;
  });
  return closedPeriodWidth;
};

export const currentTimePositionLeft = (
  minuteWidth: number,
  quarterMinuteWidth: number,
  hourWidth: number,
  timelineContent: IPlannerMinute[],
  timeNow: Date
) => {
  const closedPeriodList = timelineContent.filter((minute) =>(minute.date) <=(timeNow));
  if (closedPeriodList.length === timelineContent.length) {
    return document.body.clientWidth;
  }
  var tz = timelineContent[0].timezone;
  const mainLength = _.sumBy(closedPeriodList.slice(0, -1), (item): any => {
    const mins = (item.date).getMinutes();
    if (mins % 60 === 0) return hourWidth;
    if (mins % 15 === 0) return quarterMinuteWidth;
    return minuteWidth;
  });
 
  const lastMinutesLenth = ((timeNow).getMinutes() % 5) * (minuteWidth / 5);
  return mainLength + lastMinutesLenth;
};

export const tripPointerPosition = (
  minuteWidth: number,
  quarterMinuteWidth: number,
  hourWidth: number,
  timelineContent: IPlannerMinute[],
  tripStart: Date,
  tripEnd: Date
) => {
  const beforeTripWidth = timelineContent.filter((minute) => minute.date <= tripStart);
  const mainLength = _.sumBy(beforeTripWidth, (item): any => {
    const mins = item.date.getMinutes();
    if (mins % 60 === 0) return hourWidth;
    if (mins % 15 === 0) return quarterMinuteWidth;
    return minuteWidth;
  });
  const tripDuration = tripEnd.valueOf() - tripStart.valueOf() || 0;
  const halfTripDurationMins = Math.floor(tripDuration / 1000 / 60 / 2);
  const halfTripWidth = halfTripDurationMins * (minuteWidth / 5);
  return mainLength + halfTripWidth - 14; // 14px - pointer width
};

const getShortFullName = (firstName: string | null, lastName: string): string => `${firstName ? firstName.charAt(0) : ""} ${lastName}`;

//const getDateTimeStrForBackEnd = (date: Date) => format(date, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
const getDateTimeStrForBackEnd = (date: Date) => format(date, "yyyy-MM-dd'T'HH:mm:ss");

const LightTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 12,
    marginBottom: 30,
  },
}))(Tooltip);

const getTimeLabel = (date: Date) => `${date.getHours()}:${date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()}`;

const getPlannerLoading = () => store.appStore.getState().plannerLoadingStore.loading;

const getplannerModalStoreState = () => store.appStore.getState().plannerModalStore;

export {
  prepareTimelineContent,
  calcClosedPeriod,
  prepareTimelineLabels,
  getShortFullName,
  getDateTimeStrForBackEnd,
  getTimeLabel,
  LightTooltip,
  getDateTime,
  getPlannerLoading,
  getplannerModalStoreState,
};
